import { MethodDetailDto, MethodEditDto } from './method';

export const mapMethodDetailToEdit = (dto: MethodDetailDto): MethodEditDto => ({
  id: dto.id,
  name: dto.name,
  nameNO: dto.nameNO,
  nameEN: dto.nameEN,
  nameDE: dto.nameDE,
  description: dto.description,
  unit: dto.unit,
  instrumentGroupId: dto.instrumentGroupId,
  instrumentId: dto.instrumentId
});
